import {Route, Routes} from "react-router-dom";
import AdminLayout from "../../components/admin-layout";
import React from "react";
import ListGenerative from "./List";
import EditGenerative from "./Edit";

export default function Generative() {
  return (
    <Routes>
      <Route index path={'/'} element={
        <AdminLayout noPadding withBackground={false}>
          <ListGenerative/>
        </AdminLayout>
      }/>
      <Route path={'/:id/*'} element={
        <AdminLayout noPadding withBackground={false}>
          <EditGenerative/>
        </AdminLayout>
        }/>
    </Routes>
  )
}
